import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { HistoricInterface } from "../../common/interfaces";
import api from "../../services/api";
import { HistoricOccurrenceLabel } from "../enum/historicOccurrenceEnum";
import { TableNameEnumLabel } from "../enum/tableNameEnum";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  maxHeight: "90vh",
  bgcolor: "background.paper",
            border: "1px solid var(--border-strong)",
  boxShadow: 24,
  p: 4,
  overflowY: "auto" as const,
  borderRadius: 2
};

interface HistoricModalProps {
  open: boolean;
  onClose: () => void;
  historic_id?: number;
}

const HistoricModal: React.FC<HistoricModalProps> = ({
  open,
  onClose,
  historic_id
}) => {
  const [historic, setHistoric] = useState<HistoricInterface | null>(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!open || historic_id == null) return;

    (async () => {
      setLoading(true);
      setErrorMsg(null);
      try {
        const res = await api.get<HistoricInterface>(
          `/historic/${historic_id}`
        );
        setHistoric(res.data);
      } catch (err) {
        console.error(err);
        setErrorMsg("Erro ao carregar detalhes do histórico.");
      } finally {
        setLoading(false);
      }
    })();
  }, [open, historic_id]);

  const handleSnackbarClose = () => {
    setErrorMsg(null);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="historic-detail-modal"
      >
        <Box sx={style}>
          <Typography variant="h6" mb={2}>
            <h2>Detalhes do Histórico</h2>
          </Typography>

          {loading && (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          )}

          {!loading && historic && (
            <>
              <Box mb={2}>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>ID:</strong> {historic.historic_id}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Data:</strong>{" "}
                  {new Date(historic.historic_date).toLocaleString("pt-BR")}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Usuário:</strong> {historic.user?.user_name ?? "-"}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Empresa:</strong>{" "}
                  {historic.company?.company_name ?? "-"}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Departamento:</strong>{" "}
                  {TableNameEnumLabel[historic.historic_department]}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Ocorrência:</strong>{" "}
                  {HistoricOccurrenceLabel[historic.historic_occurrence]}
                </Typography>
                <Typography style={{ marginBottom: 5 }}>
                  <strong>Detalhes:</strong> {historic.historic_details}
                </Typography>
              </Box>

              <Box mt={3} textAlign="right">
                <Button variant="contained" onClick={onClose}>
                  Fechar
                </Button>
              </Box>
            </>
          )}

          {!loading && !historic && !errorMsg && (
            <Typography>Nenhum dado para exibir.</Typography>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default HistoricModal;
